import { createContext, type PropsWithChildren, useContext } from 'react';

import type { SidebarSortMode } from './use-sidebar-manual-order';

const NavigationPanelSidebarSortModeContext =
  createContext<SidebarSortMode | null>(null);

export function NavigationPanelSidebarSortModeProvider({
  children,
  mode,
}: PropsWithChildren<{ mode: SidebarSortMode }>) {
  return (
    <NavigationPanelSidebarSortModeContext.Provider value={mode}>
      {children}
    </NavigationPanelSidebarSortModeContext.Provider>
  );
}

export function useNavigationPanelSidebarSortMode() {
  return useContext(NavigationPanelSidebarSortModeContext);
}
